// theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1565c0', // Color celeste-azul para botones
      light: '#1976d2',
      dark: '#0d47a1',
    },
    secondary: {
      main: '#c89e38', // Color dorado para títulos
      light: '#d4b05c',
      dark: '#a17c2d',
    },
    background: {
      default: '#121212',
      paper: '#1E1E1E',
    },
    text: {
      primary: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h5: {
      color: '#c89e38', // Color dorado para títulos h5
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#ffffff',
        },
      },
    },
  },
});

export default theme;